import { atom } from 'jotai';
import { SingleTechnician, UserInfoType } from 'types/technician';
import { MarkerType, TechMarkerTypeAtSp } from 'types/marker';

// eslint-disable-next-line import/prefer-default-export
export const technicians = atom<SingleTechnician[] | []>([]);
export const userInfo = atom<UserInfoType | null>(null);
export const techMarkersAtLocation = atom<MarkerType[] | []>([]);
export const techMarkersAtSP = atom<TechMarkerTypeAtSp[] | []>([]);
